import { render } from "./UsersDeactivated.vue?vue&type=template&id=46259706&scoped=true"
import script from "./UsersDeactivated.vue?vue&type=script&lang=js"
export * from "./UsersDeactivated.vue?vue&type=script&lang=js"

import "./UsersDeactivated.vue?vue&type=style&index=0&id=46259706&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46259706"]])

export default __exports__